import axios from "axios";
import {generateCorrelationId} from "../shared/utils/correlation-id";

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API,
    headers: {
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "Content-type": "application/json; charset=UTF-8"
    }
});

api.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (!config.headers["X-Correlation-Id"]) {
        config.headers["X-Correlation-Id"] = generateCorrelationId();
    }
    return config;
});

export default api;
